import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/app/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/app/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/app/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(landing)/blog/post/[slug]/components/SinglePostContent/SingleBlockSlider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/single-blog-hero.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/single-block-locations-spaces.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/single-block-banner.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/shared/button.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/single-blog-block-container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/single-post-content.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/components/blog-box.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/assets/styles/pages/blog/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/Button/Button.tsx");
